import {
  DEVELOPMENT_STATUS_OPTIONS,
  LISTING_EDITION_REVIEW,
  PAGE_SIZE,
} from '../constants';

export function makeDevelopmentQuery(
  filters,
  searcherText,
  page,
  listingEditionReviewSelection
) {
  if (!filters) return '';

  const query = [];
  const {
    types,
    locations,
    constructionsStatus,
    status = [],
    deliveryDate = {},
    origin = [],
  } = filters;
  const { min, max } = deliveryDate;
  const { year: minYear, month: minMonth } = min || {};
  const { year: maxYear, month: maxMonth } = max || {};

  const cleanedSearch = (searcherText || '').trim();
  if (cleanedSearch) {
    query.push(`searchword=${encodeURIComponent(cleanedSearch)}`);
  }

  if (types?.id) query.push(`type=${types.id}`);
  if (locations?.id) query.push(`location=${locations.id}`);
  if (constructionsStatus?.id)
    query.push(`construction_status=${constructionsStatus.id}`);

  Object.entries(DEVELOPMENT_STATUS_OPTIONS).forEach(([key, value]) => {
    const isSelected = status.some((opt) => opt.id === Number(key));
    query.push(`${value}=${isSelected}`);
  });

  if (origin.length) {
    origin.map((originOp) => query.push(`origin=${originOp.id}`));
  }

  if (
    Array.isArray(listingEditionReviewSelection) &&
    listingEditionReviewSelection.length > 0
  ) {
    const ordered = [
      LISTING_EDITION_REVIEW.PENDING,
      LISTING_EDITION_REVIEW.REJECTED,
    ].filter((token) => listingEditionReviewSelection.includes(token));

    if (ordered.length > 0) {
      query.push(`listing_edition_review=${ordered.join(',')}`);
    }
  }

  query.push(`min_year=${minYear || 0}`);
  query.push(`min_month=${minMonth || 0}`);
  query.push(`max_year=${maxYear || 0}`);
  query.push(`max_month=${maxMonth || 0}`);

  query.push(`page=${page}`);
  query.push(`page_size=${PAGE_SIZE}`);

  return query.length ? `?${query.join('&')}` : '';
}

export function completeFilterNames(filtersSelections, filtersData) {
  const { types, locations } = filtersSelections;
  const { types: development_types, locations: development_locations } =
    filtersData || {};

  const updatedSelections = { ...filtersSelections };

  if (types?.id && !types?.name && development_types) {
    const foundType = development_types.find((type) => type.id === types.id);
    if (foundType) {
      updatedSelections.types = { ...types, name: foundType.name };
    }
  }

  if (locations?.id && !locations?.name && development_locations) {
    const foundLocation = development_locations.find(
      (location) => location.id === locations.id
    );
    if (foundLocation) {
      updatedSelections.locations = { ...locations, name: foundLocation.name };
    }
  }

  return updatedSelections;
}
